import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './App.css';
import SignIn from './pages/SignIn';
import Home from './pages/Home';
import RmaJobs from './pages/RmaJobs';
import RmaJobDetail from './pages/RmaJobDetail';
import NewRmaJob from './pages/NewRmaJob';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Router>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <Routes>
        {/* Redirect root to signin */}
        <Route path="/" element={<Navigate to="/signin" replace />} />

        {/* Auth routes */}
        <Route path="/signin" element={<SignIn />} />

        {/* Protected Home route */}
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />

        {/* Protected RMA Routes */}
        <Route
          path="/rma-jobs"
          element={
            <ProtectedRoute>
              <RmaJobs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rma-jobs/:id"
          element={
            <ProtectedRoute>
              <RmaJobDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/new-rma-job"
          element={
            <ProtectedRoute>
              <NewRmaJob />
            </ProtectedRoute>
          }
        />

        {/* Redirect /dashboard to /home for backward compatibility */}
        <Route path="/dashboard" element={<Navigate to="/home" replace />} />

        {/* Catch all - redirect to signin */}
        <Route path="*" element={<Navigate to="/signin" replace />} />
      </Routes>
    </Router>
  );
}

export default App;